import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { FloorMap } from '../floor-map.model';
import { FloorMapActions, FloorMapActionTypes } from '../actions/floor-map.actions';

export interface State extends EntityState<FloorMap> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<FloorMap> = createEntityAdapter<FloorMap>();

export const initialState: State = adapter.getInitialState({
  Loaded: false,
  Loading: false
});

export function reducer(
  state = initialState,
  action: FloorMapActions
): State {
  switch (action.type) {
    case FloorMapActionTypes.AddFloorMap: {
      return adapter.addOne(action.payload.floorMap, state);
    }

    case FloorMapActionTypes.UpsertFloorMap: {
      return adapter.upsertOne(action.payload.floorMap, state);
    }

    case FloorMapActionTypes.AddFloorMaps: {
      return adapter.addMany(action.payload.floorMaps, state);
    }

    case FloorMapActionTypes.UpsertFloorMaps: {
      return adapter.upsertMany(action.payload.floorMaps, state);
    }

    case FloorMapActionTypes.UpdateFloorMap: {
      return adapter.updateOne(action.payload.floorMap, state);
    }

    case FloorMapActionTypes.UpdateFloorMaps: {
      return adapter.updateMany(action.payload.floorMaps, state);
    }

    case FloorMapActionTypes.DeleteFloorMap: {
      return adapter.removeOne(action.payload.id, state);
    }

    case FloorMapActionTypes.DeleteFloorMaps: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case FloorMapActionTypes.LoadFloorMaps: {
      return adapter.setAll(action.payload.floorMaps, {
        ...state,
        Loaded: true,
        Loading: false
      });
    }

    case FloorMapActionTypes.ClearFloorMaps: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
